export const getCheckmarkColor = ({ isDisabled, isReadOnly, isInvalid, }) => {
    if (isInvalid) {
        return "semantic.icon.error";
    }
    if (isDisabled) {
        return "semantic.icon.disabled";
    }
    if (isReadOnly) {
        return "semantic.icon.secondary";
    }
    return "semantic.interactive.primary";
};
//# sourceMappingURL=Checkbox.helpers.js.map